// import CloudContentLogo from "./icons/CloudContentLogo";
import CloudContentLogo from "../assets/images/cc_logo_dark.png";



const LoadingOverlay = () => {
    return (
        <div data-testid="loading-overlay" className="fixed inset-0 flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm">
            {/* <CloudContentLogo /> */}
            <img
                src={CloudContentLogo}
                width={150}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginLeft: "auto",
                }}
                alt=""
            />
            <div data-testid="progress-container" className="w-48 h-1 mt-6 bg-gray-200 rounded-full overflow-hidden">
                <div data-testid="progress-bar" className="h-full rounded-full animate-loading" style={{
                    background: 'linear-gradient(90deg, rgba(62,142,255,1) 0%, rgba(36,93,173,1) 35%)',
                }} />
            </div>
        </div>
    );
}

export default LoadingOverlay;